import * as yup from 'yup';

export const UpdateConf = {
  schema: yup.object({
    name: yup.string().nullable().required('Name is required'),
  }),
  defaultValues: {
    name: null,
  },
  fields: [
    {
      id: 'name',
      name: 'name',
      type: 'text',
      label: 'Name',
      required: true,
      xs: 12,
    },
  ],
};
